import { ActionReducerMap } from '@ngrx/store';
import { AllActionsUnion } from './app.actions';
import {
  restaurantPageReducer,
  RestaurantPageState,
} from './pages/restaurant/store/restaurant-page.reducer';
import {
  accountReducer,
  AccountState,
} from './pages/shared/account/account.reducer';
import {
  agreementStatusesReducer,
  AgreementStatusesState,
} from './pages/shared/agreement-statuses/agreement-statuses.reducer';
import {
  areaRestaurantPageReducer,
  AreaRestaurantPageState,
} from './pages/shared/area-restaurant-page/area-restaurant-page.reducer';
import {
  maintenanceReducer,
  MaintenanceState,
} from './pages/shared/maintenance/maintenance.reducer';
import {
  reauthReducer,
  ReauthState,
} from './pages/shared/reauth/reauth.reducers';
import {
  reservationReducer,
  ReservationState,
} from './pages/shared/reservation/reservation.reducer';
import {
  reservationsReducer,
  ReservationsState,
} from './pages/shared/reservations/reservations.reducer';
import {
  restaurantReducer,
  RestaurantState,
} from './pages/shared/restaurant/restaurant.reducer';
import {
  searchReducer,
  SearchState,
} from './pages/shared/search/search.reducer';
import {
  signInReducer,
  SignInState,
} from './pages/shared/sign-in/sign-in.reducer';
import {
  signUpReducer,
  SignUpState,
} from './pages/shared/sin-up/sign-up.reducer';
import {
  userProfileReducer,
  UserProfileState,
} from './pages/shared/user-profile/user-profile.reducer';
import {
  userReservationReducer,
  UserReservationState,
} from './pages/shared/user-reservation/user-reservation.reducer';
import {
  withdrawReducer,
  WithdrawState,
} from './pages/shared/withdraw/withdraw.reducers';

interface CombinedState {
  userProfileFeature: UserProfileState;
  signInFeature: SignInState;
  signUpFeature: SignUpState;
  searchFeature: SearchState;
  restaurantFeature: RestaurantState;
  reservationFeature: ReservationState;
  reservationsFeature: ReservationsState;
  accountFeature: AccountState;
  reauthFeature: ReauthState;
  withdrawFeature: WithdrawState;
  agreementStatusesFeature: AgreementStatusesState;
  maintenanceFeature: MaintenanceState;
  restaurantPageFeature: RestaurantPageState;
  userReservationFeature: UserReservationState;
  areaRestaurantPageFeature: AreaRestaurantPageState;
}

export const reducers: ActionReducerMap<CombinedState, AllActionsUnion> = {
  userProfileFeature: userProfileReducer,
  signInFeature: signInReducer,
  signUpFeature: signUpReducer,
  searchFeature: searchReducer,
  restaurantFeature: restaurantReducer,
  reservationFeature: reservationReducer,
  reservationsFeature: reservationsReducer,
  accountFeature: accountReducer,
  reauthFeature: reauthReducer,
  withdrawFeature: withdrawReducer,
  agreementStatusesFeature: agreementStatusesReducer,
  maintenanceFeature: maintenanceReducer,
  restaurantPageFeature: restaurantPageReducer,
  userReservationFeature: userReservationReducer,
  areaRestaurantPageFeature: areaRestaurantPageReducer,
};
